
export const serviceCategories = [
  {
    id: 'intimate',
    title: 'Intimate Gatherings',
    icon: 'ri-cake-2-line',
    tagline: 'Personal Celebrations, Beautifully Styled',
    description: 'Specialising in intimate celebrations for 30-80 guests. Whether it\'s a milestone birthday, anniversary, engagement party, or special occasion, we create beautifully styled events that feel personal and memorable.',
    image: 'https://public.readdy.ai/ai/img_res/91c7723c3bec6f94a682a9d3560e288c.jpg',
    features: [
      'Custom decor styling and theme design',
      'Balloon installations and arches',
      'Table settings and centerpieces',
      'Complete setup and breakdown',
      'Equipment hire included',
      'Venue transformation',
      'Day-of coordination',
      'Flexible styling packages',
    ],
  },
  {
    id: 'decorations',
    title: 'Decoration Services',
    icon: 'ri-palette-line',
    tagline: 'Transform Your Space',
    description: 'Professional decoration styling that brings your vision to life. From elegant balloon installations to stunning table settings, we handle all the details to create a cohesive, beautiful atmosphere for your event.',
    image: 'https://readdy.ai/api/search-image?query=professional%20event%20decoration%20setup%20with%20elegant%20balloon%20garland%20in%20soft%20colors%2C%20styled%20dessert%20table%20with%20beautiful%20backdrop%2C%20floral%20arrangements%2C%20ambient%20string%20lights%2C%20modern%20party%20styling%20for%20intimate%20gathering%2C%20warm%20inviting%20atmosphere%2C%20professional%20photography&width=600&height=400&seq=svc-decor-detail-01&orientation=landscape',
    features: [
      'Balloon garlands and installations',
      'Backdrop and photo wall design',
      'Table styling and linens',
      'Floral arrangements',
      'Ambient lighting setup',
      'Dessert table styling',
      'Color scheme coordination',
      'Setup and pack down included',
    ],
  },
  {
    id: 'small-events',
    title: 'Small Gatherings',
    icon: 'ri-group-line',
    tagline: 'Perfectly Sized Celebrations',
    description: 'Ideal for baby showers, bridal showers, small family celebrations, and intimate get-togethers. We provide personalised service and attention to detail for groups up to 80 people.',
    image: 'https://readdy.ai/api/search-image?query=elegant%20small%20gathering%20setup%20with%20beautifully%20decorated%20round%20tables%2C%20soft%20pastel%20color%20scheme%2C%20intimate%20seating%20arrangement%20for%2050%20guests%2C%20cozy%20celebration%20decor%20with%20floral%20centerpieces%2C%20warm%20lighting%2C%20professional%20event%20styling%20photography&width=600&height=400&seq=svc-small-detail-01&orientation=landscape',
    features: [
      'Personalised styling consultation',
      'Complete venue transformation',
      'Theme development and execution',
      'Day-of coordination',
      'Equipment and furniture hire',
      'Flexible package options',
      'Setup and breakdown service',
      'Vendor coordination',
    ],
  },
  {
    id: 'equipment',
    title: 'Equipment Hire',
    icon: 'ri-truck-line',
    tagline: 'Premium Pieces, Delivered',
    description: 'Access our curated collection of premium acrylic glassware, furniture, and party essentials. Perfect for DIY events or to complement our styling services. Delivery, setup, and collection included.',
    image: 'https://readdy.ai/api/search-image?query=elegant%20event%20equipment%20showroom%20with%20premium%20gold%20chiavari%20chairs%2C%20round%20banquet%20tables%20with%20white%20linen%2C%20crystal%20glassware%20display%2C%20professional%20lighting%20rigs%20arranged%20neatly%2C%20clean%20organized%20luxury%20event%20rental%20warehouse%20with%20warm%20ambient%20lighting%2C%20professional%20photography&width=600&height=400&seq=svc-equip-detail-01&orientation=landscape',
    features: [
      'Acrylic glassware collection',
      'Furniture and seating hire',
      'Delivery and collection',
      'Professional setup available',
      'Flexible hire durations',
      'Custom package building',
      'Same-week availability',
      'Damage waiver options',
    ],
  },
];

export const pricingPackages = [
  {
    id: 'starter',
    name: 'Starter',
    tagline: 'Perfect for small gatherings',
    price: 650,
    priceLabel: 'Starting from',
    priceSuffix: '/event',
    popular: false,
    features: [
      { text: 'Up to 30 guests', included: true },
      { text: 'Basic decor styling', included: true },
      { text: 'Balloon installation', included: true },
      { text: 'Setup and breakdown', included: true },
      { text: 'Equipment hire (basic)', included: true },
      { text: 'Styling consultation', included: true },
      { text: 'Day-of coordination', included: false },
      { text: 'Custom theme design', included: false },
      { text: 'Floral arrangements', included: false },
      { text: 'Premium furniture hire', included: false },
    ],
    cta: 'Get Started',
  },
  {
    id: 'signature',
    name: 'Signature',
    tagline: 'Our most popular choice',
    price: 1200,
    priceLabel: 'Starting from',
    priceSuffix: '/event',
    popular: true,
    features: [
      { text: 'Up to 60 guests', included: true },
      { text: 'Full decor styling', included: true },
      { text: 'Custom balloon installations', included: true },
      { text: 'Complete setup & breakdown', included: true },
      { text: 'Equipment hire (premium)', included: true },
      { text: 'Theme design consultation', included: true },
      { text: 'Day-of coordination', included: true },
      { text: 'Table styling & centerpieces', included: true },
      { text: 'Floral arrangements', included: true },
      { text: 'Lighting setup', included: false },
    ],
    cta: 'Choose Signature',
  },
  {
    id: 'premium',
    name: 'Premium',
    tagline: 'Complete styling experience',
    price: 2200,
    priceLabel: 'Starting from',
    priceSuffix: '/event',
    popular: false,
    features: [
      { text: 'Up to 80 guests', included: true },
      { text: 'Complete venue transformation', included: true },
      { text: 'Luxury balloon installations', included: true },
      { text: 'Full setup & breakdown', included: true },
      { text: 'All equipment included', included: true },
      { text: 'Custom theme design', included: true },
      { text: 'Full day-of coordination', included: true },
      { text: 'Premium table styling', included: true },
      { text: 'Floral design & arrangements', included: true },
      { text: 'Ambient lighting included', included: true },
    ],
    cta: 'Go Premium',
  },
];

export const addOns = [
  { icon: 'ri-camera-lens-line', name: 'Photography', price: 'From $350', description: 'Professional event photography' },
  { icon: 'ri-flower-line', name: 'Extra Florals', price: 'From $180', description: 'Additional floral installations' },
  { icon: 'ri-lightbulb-line', name: 'Uplighting', price: 'From $150', description: 'Ambient LED lighting' },
  { icon: 'ri-gift-line', name: 'Party Favours', price: 'From $4/guest', description: 'Custom guest gifts' },
  { icon: 'ri-restaurant-line', name: 'Catering Coordination', price: 'From $200', description: 'Vendor coordination service' },
  { icon: 'ri-music-2-line', name: 'Entertainment', price: 'From $400', description: 'DJ or live music booking' },
  { icon: 'ri-cake-3-line', name: 'Dessert Table', price: 'From $250', description: 'Styled dessert display' },
  { icon: 'ri-image-line', name: 'Photo Booth', price: 'From $300', description: 'Backdrop and props included' },
];

export const processSteps = [
  { step: 1, title: 'Initial Consultation', description: 'We discuss your vision, guest count, and budget in a free consultation call or meeting.', icon: 'ri-phone-line' },
  { step: 2, title: 'Custom Proposal', description: 'Within 48 hours, receive a tailored proposal with styling ideas, mood boards, and detailed pricing.', icon: 'ri-file-list-3-line' },
  { step: 3, title: 'Planning & Styling', description: 'We handle all the details — decor sourcing, equipment hire, timeline planning, and coordination.', icon: 'ri-palette-line' },
  { step: 4, title: 'Event Day Setup', description: 'We arrive early to set up everything perfectly, so you can relax and enjoy your celebration.', icon: 'ri-sparkling-2-line' },
];
